import { render, staticRenderFns } from "./c_register.vue?vue&type=template&id=16e1dc1c&scoped=true&"
import script from "./c_register.vue?vue&type=script&lang=js&"
export * from "./c_register.vue?vue&type=script&lang=js&"
import style0 from "./c_register.vue?vue&type=style&index=0&id=16e1dc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e1dc1c",
  null
  
)

export default component.exports